import { Button, Card, message } from "antd";
import React, { useEffect, useState } from "react";
import { API_METHODS, BLANK_VALUE } from "../../../constants";
import useApi from "../../../hooks/useApi";
import AddSuchana from "./AddSuchana";
import { arrayMove } from "@dnd-kit/sortable";
import DraggableTableContent from "../../common/DraggableTableContent";

function SuchanaTable() {
  const [visible, setVisible] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState();
  const [messageApi, contextHolder] = message.useMessage();

  const keys = ["suchana"];
  const headers = ["Suchana"];

  const [responseData, getRequest] = useApi(
    `/admin/suchana`,
    null,
    API_METHODS.GET
  );
  const [deleteResponse, deleteRequest] = useApi();

  const [reorderResponse, reorderRequest] = useApi(
    `/admin/suchana/reorder`,
    null,
    API_METHODS.POST
  );

  useEffect(() => {
    getRequest();
  }, []);

  useEffect(() => {
    const data =
      responseData.data !== BLANK_VALUE && responseData.data !== null
        ? responseData.data
        : [];
    setTableData(data);
  }, [responseData]);

  useEffect(() => {
    if (deleteResponse.data && !deleteResponse.isLoading) {
      getRequest();
      messageApi.open({
        type: "success",
        content: "Suchana Deleted successfully",
      });
    }
  }, [deleteResponse]);

  useEffect(() => {
    if (reorderResponse?.data && !reorderResponse.isLoading) {
      getRequest();
    }
  }, [reorderResponse]);

  const handleAddSuchana = (isUpdated) => {
    const flag = visible ? false : true;
    setVisible(flag);
    if (isUpdated === true) {
      getRequest();
    }
  };

  const handleEditSuchana = (isUpdated) => {
    const flag = visibleEdit ? false : true;
    !flag && setSelectedRecord(null);
    setVisibleEdit(flag);
    if (isUpdated === true) {
      getRequest();
    }
  };

  const editRecord = (record) => {
    setVisibleEdit(true);
    setSelectedRecord(record);
  };

  const deleteRecord = (record) => {
    deleteRequest(null, API_METHODS.DELETE, `/admin/suchana/${record.id}`);
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (active.id !== over.id) {
      const oldIndex = tableData.findIndex((text) => text.id === active.id);
      const newIndex = tableData.findIndex((text) => text.id === over.id);

      const newData = arrayMove(tableData, oldIndex, newIndex);
      setTableData(newData);
      let new_order = newData.map((item) => item.id);
      let data = { new_order };
      reorderRequest(data);
    }
  };

  return (
    <Card title="सूचना फलक"
      extra={
        <Button type="primary" onClick={handleAddSuchana}>
          Add Suchana
        </Button>
      }
    >
      {contextHolder}

      <DraggableTableContent
        tableData={tableData}
        headers={headers}
        keys={keys}
        onDragEnd={handleDragEnd}
        onEdit={editRecord}
        onDelete={deleteRecord}
      />
      {visible && <AddSuchana visible={visible} close={handleAddSuchana} />}
      {visibleEdit && (
        <AddSuchana
          visible={visibleEdit}
          selectedRecord={selectedRecord}
          close={handleEditSuchana}
        />
      )}
    </Card>
  );
}

export default SuchanaTable;
